import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { AlertPopupService, MessageSeverity, AlertMessage } from './shared/services/alert.service';
import { ToastyService, ToastOptions, ToastData, ToastyConfig } from 'ng2-toasty';
import { MemberService } from './_services/member.service';
import { WhitelabelService } from './_services/whitelabel.service';
import { ConfigService } from './_services/config.service';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { ApiService } from './_services';
import * as _ from 'lodash';
import { Dependent } from './_models/dependent.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    public static hasSSOTelemed: boolean = true;
    isLoggedin = false;
    currentShop :any={};
    stickyToasties: number[] = [];
    isDependent = false;
    currentDependent: Dependent;
    public static whitelabel: any = {};
    public static siteContact : any ={};
    public static siteBranding: any = {};
    selectedPolicy:any;
    AppComponent=AppComponent;

    prescriptioncard: any;

    constructor(public whitelabelService: WhitelabelService,
         public memberService: MemberService, 
         private alertService: AlertPopupService, 
         private toastyService: ToastyService, 
         private toastyConfig: ToastyConfig,
         private configService: ConfigService,
         private router: Router,
         private apiService: ApiService,

         @Inject(DOCUMENT) private _document: HTMLDocument
         ) {

            this.toastyConfig.theme = 'bootstrap';
            this.toastyConfig.position = 'top-right';
            this.toastyConfig.limit = 100;
            this.toastyConfig.showClose = true;

            if (localStorage.getItem('openIdTokenParams')) {
                // logged in so return true
                this.isLoggedin = true;
            }
            // console.log(JSON.parse(localStorage.getItem('currentDependent')))
            
    }

    
    policyChanged(){
        console.log(this.selectedPolicy)
        this.whitelabelService.getWhitelabelByProductId(this.selectedPolicy.productId).subscribe(r=>{
            var member = this.memberService.currentMember;
            var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));

             this.apiService.checkPreRegisterTelemed(member.memberId, this.selectedPolicy.productId).subscribe()

            window.location.href = `https://${r.siteUrl}/login-with-token?memberId=${member.memberId}&code=${openIdTokenParams.id_token}&productId=${this.selectedPolicy.productId}`;
        });
    }

    ngOnInit() {
        this.alertService.getMessageEvent().subscribe(message => this.showToast(message, false));
        this.alertService.getStickyMessageEvent().subscribe(message => this.showToast(message, true));
        this.memberService.memberChanged.subscribe(r=>{
            if(this.memberService.currentMember){
                this.selectedPolicy = _.find(this.memberService.currentMember.memberPolicies, {productId :AppComponent.whitelabel.productId })
                if(!this.selectedPolicy){
                    this.selectedPolicy = this.memberService.currentMember.memberPolicies[0];
                }
            }

        })

        this.prescriptioncard = JSON.parse(this.whitelabelService.getSettingByFeatureName('prescriptioncard'));
        this.memberService.currentDependent.subscribe(d => {
            this.isDependent = false;
            if(d){
                this.isDependent = true;
                this.currentDependent = d
            }
            // console.log(this.isDependent)
        })
    }

    ngAfterViewInit(){
        if(!this.whitelabelService.isLoading){
            this.initWhitelabel();
        }else{
            this.whitelabelService.loadedEvent.subscribe(r=>{
                this.initWhitelabel();
            })
        }

    }


    logout(){
        this.memberService.logout();
        this.router.navigateByUrl("/login")
    }

    private async initWhitelabel() {
        AppComponent.siteContact = JSON.parse(this.whitelabelService.getSettingByFeatureName('sitecontact'));
        AppComponent.siteBranding = JSON.parse(this.whitelabelService.getSettingByFeatureName('sitebranding'));
        AppComponent.siteContact.benefitsPhoneRaw = AppComponent.siteContact.benefitsPhone.split("-").join("");
        AppComponent.whitelabel = await this.whitelabelService.getWhitelabelByUrl().toPromise();
        window.document.title = AppComponent.siteBranding.brandname;
        $("link[rel*='icon']").attr("href", AppComponent.siteBranding.faviconurl);
        //console.log(AppComponent.siteBranding.initScripts)
        var div_scripts=  $('#div_scripts').load(AppComponent.siteBranding.initScripts, function(){
            $('body').append(div_scripts[0].innerHTML);
        })

        this.memberService.memberChanged.subscribe(()=>{
            // console.log(AppComponent.whitelabel.productId);
            _.each(this.memberService.currentMember.memberPolicies, mp=>{
                if(mp.productId == AppComponent.whitelabel.productId){
                    this.selectedPolicy = mp;
                    
                }
            });
        })

    }

    showToast(message: AlertMessage, isSticky: boolean) {
        
        if (message == null) {
            for (let id of this.stickyToasties.slice(0)) {
                this.toastyService.clear(id);
            }

            return;
        }

        let toastOptions: ToastOptions = {
            title: message.summary,
            msg: message.detail,
            timeout: isSticky ? 0 : 4000,
            
            
        };
        

        if (isSticky) {
            toastOptions.onAdd = (toast: ToastData) => {
                this.stickyToasties.push(toast.id);
            
            }
            
            toastOptions.onRemove = (toast: ToastData) => {
                let index = this.stickyToasties.indexOf(toast.id, 0);

                if (index > -1) {
                    this.stickyToasties.splice(index, 1);
                }

                toast.onAdd = null;
                toast.onRemove = null;
            };
        }


        switch (message.severity) {
            case MessageSeverity.default: this.toastyService.default(toastOptions); break
            case MessageSeverity.info: this.toastyService.info(toastOptions); break;
            case MessageSeverity.success: this.toastyService.success(toastOptions); break;
            case MessageSeverity.error: this.toastyService.error(toastOptions); break
            case MessageSeverity.warn: this.toastyService.warning(toastOptions); break;
            case MessageSeverity.wait: this.toastyService.wait(toastOptions); break;
        }
    }

    

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts